export default "__VITE_ASSET__DcSSR5E4__"